import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { BrandRowData } from '../types';

@Component({
  selector: 'app-brand-selection-renderer',
  imports: [CommonModule],
  templateUrl: './brand-selection-renderer.component.html',
  styleUrl: './brand-selection-renderer.component.scss'
})
export class BrandSelectionRendererComponent implements ICellRendererAngularComp {

  protected displayButtons: boolean = true;
  protected brands: BrandRowData[] = [];
  private onBrandClicked: (brand: BrandRowData) => void = () => {};
  private onSelectAllClicked: (brands: BrandRowData[]) => void = () => {};
  private onDeselectAllClicked: (brands: BrandRowData[]) => void = () => {};

  agInit(params: ICellRendererParams): void {
    this.loadComponent(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.loadComponent(params);
    return true;
  }

  private loadComponent(params: ICellRendererParams): void {
    this.onBrandClicked = (params as any).onBrandClicked;
    this.onSelectAllClicked = (params as any).onSelectAllClicked;
    this.onDeselectAllClicked = (params as any).onDeselectAllClicked;
    this.displayButtons = (params as any).displayButtons ?? true;

    const value = params.value?.value || params.value;
    if (Array.isArray(value)) {
      this.brands = value;
    } else if (value) {
      this.brands = [value];
    }
  }

  protected handleBrandClick(brand: BrandRowData): void {
    brand.isSelected = !brand.isSelected;
    this.onBrandClicked(brand);
  }

  protected handleSelectAllClick(): void {
    this.brands.forEach(brand => brand.isSelected = true);
    this.onSelectAllClicked(this.brands);
  }

  protected handleDeselectAllClick(): void {
    this.brands.forEach(brand => brand.isSelected = false);
    this.onDeselectAllClicked(this.brands);
  }

  protected onIconError(event: Event): void {
    (event.target as HTMLImageElement).src = 'images/no-logo.png';
  }
}
